import React from 'react';

import { HeaderOpeningHours } from './header-opening-hours';
import LinkWrapper from '../link-wrapper/link-wrapper';
import ImageWrapper from '../image-wrapper/Image-wrapper';

interface HeaderProps {
  logo: any;
  meetingPlace: any;
}
export const Header = ({ logo, meetingPlace }: HeaderProps) => {
  const aspectRatio =
    logo?.width && logo?.height ? logo.width / logo.height : undefined;
  return (
    <header className="absolute left-6 right-7 top-0 z-10 lg:right-28">
      <div className="lg:mt-6">
        <div className="grid w-full grid-cols-11 items-end gap-5 pt-6 lg:items-start lg:pt-0">
          <div className="col-span-5 w-fit lg:pt-3">
            <LinkWrapper
              data={`/${meetingPlace?.sys?.locale?.toLowerCase()}/`}
              className="relative block lg:ml-22"
            >
              <ImageWrapper
                className={aspectRatio == 1 ? 'max-h-14 w-36' : 'max-h-10 w-36'}
                alt={''}
                url={logo?.url}
                imgClassName={
                  aspectRatio == 1 ? 'max-h-14 !w-auto' : 'max-h-10 !w-auto'
                }
                height={logo?.height}
                width={logo?.width}
              />
            </LinkWrapper>
          </div>
          {meetingPlace && (
            <div className="col-span-6 flex justify-end">
              <HeaderOpeningHours
                meetingPlace={meetingPlace}
                openingHoursLink={meetingPlace?.openingHoursLink}
              />
            </div>
          )}
        </div>
        <LinkWrapper
          data={`/${meetingPlace?.sys?.locale?.toLowerCase()}/`}
          className="relative block lg:hidden"
        >
          <div className="mt-3 font-title text-headingxs text-text-default">
            {meetingPlace.name}
          </div>
        </LinkWrapper>
      </div>
    </header>
  );
};
